module.exports = __webpack_public_path__ + "static/juber-d8eebcce3ee114fea772828e6f900a96.jpg";